import { api, type ProjectView } from '../../lib/client.ts';
import { RecordCustomFields } from '../fields/record-custom-fields.tsx';

/**
 * The project's custom fields on its Overview (TS-1756), grouped by the organisation's project
 * layout (Settings → Fields → Projects, TS-1752); a card of its own. The drawing, editing and
 * per-role access are `RecordCustomFields`, shared with an expanded job's block.
 */
export function ProjectCustomFields({
  project,
  canWrite,
  onSaved,
}: {
  project: ProjectView;
  canWrite: boolean;
  onSaved: () => Promise<void>;
}) {
  return (
    <RecordCustomFields
      entity="projects"
      values={project.custom}
      canWrite={canWrite}
      save={(custom) => api.projects.patch(project.id, { custom })}
      onSaved={onSaved}
      testId="project-custom-fields"
    />
  );
}
